import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "mt-4",
  style: {"width":"100%","overflow":"auto"}
}

import moment from "moment";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import ReportType from "@/core/enums/ReportTypes.enums";
import { formatMonthQuery } from "@/core/helpers/bao-cao-pdf-params";
import { openBaoCaoPdf } from "@/components/shared/pdf-viewer/open-bao-cao-pdf";
import { CapSuaChuaService } from "@/core/services/CapSuaChuaService.service";
import {
  getErrorMsg,
  swalErrNotification,
  swalNotification,
} from "@/core/helpers/utils";
import {
  IBangKeChiTietXuatResponseBase,
  ICapSuaChuaResponseBase,
  IKhoResponseBase,
  IToaXeCapSuaChuaReportResponseBase,
} from "@/core/interfaces/ApiResponses";
import { BaoCaoService } from "@/core/services/BaoCao.service";
import { KhoService } from "@/core/services/Kho.service";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { useCreatingForm } from "@/core/hooks/use-creating-form";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import { useLoading } from "@/core/hooks/use-loading";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import debounce from "lodash/debounce";
import BangKeChiTietXuatPrintModal from "@/views/crafted/pages/bao-cao/print-modals/BangKeChiTietXuatPrintModal.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import ChiTietXuatTable from "./table-components/ChiTietXuatTable.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageContentSection from "@/layout/_shared/PageContentSection.vue";
import ResponsiveLayout from "@/layout/_shared/ResponsiveLayout.vue";
import IconInfoCircleClassicSolid from "@/icons/IconInfoCircleClassicSolid.vue";
import useFormInput from "@/core/hooks/use-form-input";
import CapSuaChuaSearchInput from "@/components/shared/cap-sua-chua-search-input/CapSuaChuaSearchInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BangKeChiTietXuat',
  setup(__props) {

setCurrentPageTitle("Bảng kê chi tiết xuất");

setBreadcrumbLinks([
  {
    text: "Báo cáo",
  },
  {
    text: "Bảng kê chi tiết xuất",
  },
]);

document.title = "Bảng kê chi tiết xuất - Đường sắt Hà Nội";
const { formRef } = useCreatingForm();
const { startLoading, endLoading } = useLoading();
const { ButtonsType, ButtonTypeColors } = useButtonCustom();
const capSuaChuaItems = ref<ICapSuaChuaResponseBase[]>([]);
const store = useStore();
const router = useRouter();
const currentYear = computed(() => store.getters.getSelectedYear);
const { disableDate, defaultDate } = useDateTime();

const form = ref({
  capSuaChuaId: -1,
  from: defaultDate.value,
  to: defaultDate.value,
  khoId: -1,
  toaXeId: -1,
});

const fetchCapSuaChuaItems = async () => {
  try {
    startLoading();

    const {
      data: {
        data: { data },
      },
    } = await CapSuaChuaService.list({});

    capSuaChuaItems.value = data;

    endLoading();
  } catch (e) {
    endLoading();
    swalNotification(
      getErrorMsg(e, "Có lỗi khi lấy thông tin cấp sửa chữa"),
      "error"
    );
  }
};

const khoItems = ref<IKhoResponseBase[]>([]);
const searchingToaXe = ref(false);

const fetchKhoItems = async () => {
  startLoading();

  try {
    const {
      data: {
        data: { data },
      },
    } = await KhoService.fetchAllWarehouses();

    khoItems.value = data;

    endLoading();
  } catch (e) {
    endLoading();

    swalErrNotification(e, "Có lỗi khi lấy danh sách kho");
  }
};

const searchToaXe = debounce(async (query) => {
  searchingToaXe.value = true;

  const {
    data: { data },
  } = await BaoCaoService.searchToaXeTheoCapSuaChuaReport({
    id_cap_sc: form.value.capSuaChuaId,
    s: query,
  });

  toaXeTheoCapSuaChuaItems.value = data;

  searchingToaXe.value = false;
}, 1000);

onMounted(() => {
  nextTick(async () => {
    await fetchCapSuaChuaItems();

    await fetchKhoItems();
  });
});

const isFiltersChanging = ref(true);

const fromDateValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập"));
  }

  if (value && form.value.to && moment(value).isAfter(form.value.to)) {
    callback(new Error("Ngày bắt đầu phải trước ngày kết thúc"));
  }

  callback();
};

const toDateValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập"));
  }

  if (value && form.value.from && moment(value).isBefore(form.value.from)) {
    callback(new Error("Ngày bắt đầu phải trước ngày kết thúc"));
  }

  callback();
};

const rules = ref({
  capSuaChuaId: [
    {
      type: "number",
      message: "Phải chọn cấp sửa chữa",
      trigger: "change",
      min: 1,
    },
  ],
  from: [
    {
      validator: fromDateValidation,
      trigger: "change",
    },
  ],
  to: [
    {
      validator: toDateValidation,
      trigger: "change",
    },
  ],
  khoId: [
    {
      type: "number",
      message: "Phải chọn kho",
      trigger: "change",
      min: 1,
    },
  ],
  toaXeId: [
    {
      type: "number",
      message: "Phải chọn toa xe",
      trigger: "change",
      min: 1,
    },
  ],
});

const selectingKho = computed(() => {
  if (!form.value.khoId) return null;

  return khoItems.value.find(({ id }) => id === form.value.khoId);
});

const selectingCapSuaChua = computed(() => {
  if (!form.value.capSuaChuaId) return null;

  return capSuaChuaItems.value.find(({ id }) => id === form.value.capSuaChuaId);
});

const selectingToaXe = computed(() => {
  if (!form.value.toaXeId) return null;

  return toaXeTheoCapSuaChuaItems.value.find(
    ({ toa_xe: { id } }) => id === form.value.toaXeId
  );
});

const showPrintButton = computed(() => {
  if (isFiltersChanging.value) return false;

  if (!chiTietXuatItems.value.length) return false;

  if (
    !selectingKho.value ||
    !selectingCapSuaChua.value ||
    !form.value.from ||
    !form.value.to ||
    !form.value.toaXeId
  )
    return false;

  return true;
});

watch(
  form,
  () => {
    isFiltersChanging.value = true;
  },
  {
    deep: true,
    immediate: true,
  }
);

const chiTietXuatItems = ref<IBangKeChiTietXuatResponseBase[]>([]);

const { focusFirstErrInputV2 } = useFormInput();

const generateBaoCao = () => {
  if (!formRef.value) return;

  formRef.value.validate(async (isValid) => {
    if (isValid) {
      startLoading();

      try {
        isFiltersChanging.value = false;

        const {
          data: { data },
        } = await BaoCaoService.getBangKeChiTietXuat({
          capSuaChuaId: form.value.capSuaChuaId,
          khoId: form.value.khoId,
          from: form.value.from.getMonth() + 1,
          to: form.value.to.getMonth() + 1,
          toaXeId: form.value.toaXeId,
        });

        chiTietXuatItems.value = data;

        await endLoading();
      } catch (e) {
        await endLoading();

        swalErrNotification(e, "Có lỗi khi lấy danh sách kho");
      }
    } else {
      await focusFirstErrInputV2();

      return false;
    }
  });
};

const bangKeChiTietXuatPrintModalRef = ref();

const openPdfViewer = () => {
  openBaoCaoPdf(router, {
    reportType: ReportType.BANG_KE_CHI_TIET_XUAT,
    from: formatMonthQuery(form.value.from),
    to: formatMonthQuery(form.value.to),
    khoId: form.value.khoId,
    capSuaChuaId: form.value.capSuaChuaId,
    toaXeId: form.value.toaXeId,
    toaXeTen: selectingToaXe.value?.toa_xe?.ten_toa_xe,
    toaXeMa: selectingToaXe.value?.toa_xe?.ma_toa_xe,
    capSuaChuaTen: selectingCapSuaChua.value?.ten_cap_sc,
  });
};

const toaXeTheoCapSuaChuaItems = ref<IToaXeCapSuaChuaReportResponseBase[]>([]);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BangKeChiTietXuatPrintModal, {
      ref_key: "bangKeChiTietXuatPrintModalRef",
      ref: bangKeChiTietXuatPrintModalRef,
      "cap-sua-chua": selectingCapSuaChua.value ?? null,
      from: new Date(form.value.from) ?? null,
      to: new Date(form.value.to) ?? null,
      kho: selectingKho.value ?? null,
      items: chiTietXuatItems.value,
      "toa-xe": selectingToaXe.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (bangKeChiTietXuatPrintModalRef.value.isOpen = false))
    }, null, 8, ["cap-sua-chua", "from", "to", "kho", "items", "toa-xe"]),
    _createVNode(PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(PageContentSection, { "always-expanded": true }, {
          header: _withCtx(() => [
            _createTextVNode(" Bảng kê chi tiết xuất ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "formRef",
              ref: formRef,
              model: form.value,
              rules: rules.value,
              onSubmit: _withModifiers(generateBaoCao, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-text-muted": false,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Kho:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "khoId",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.khoId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.khoId) = $event)),
                          class: "w-100",
                          name: "khoId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              disabled: "",
                              label: "Chưa chọn",
                              value: -1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(khoItems.value, (kho) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: kho.id,
                                label: kho.ten_kho,
                                value: kho.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-text-muted": false,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Từ tháng:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "from",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: form.value.from,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.from) = $event)),
                          class: "w-100",
                          "disabled-date": (time) => _unref(disableDate)(time, currentYear.value, true),
                          type: "month",
                          placeholder: "Từ",
                          name: "from",
                          format: "MM/YYYY"
                        }, null, 8, ["modelValue", "disabled-date"])
                      ]),
                      _: 1
                    })
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-text-muted": false,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Đến tháng:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-4": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "to",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: form.value.to,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.to) = $event)),
                          class: "w-100",
                          "disabled-date": (time) => _unref(disableDate)(time, currentYear.value, true),
                          placeholder: "Đến",
                          name: "to",
                          format: "MM/YYYY",
                          type: "month"
                        }, null, 8, ["modelValue", "disabled-date"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-text-muted": false,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cấp S/C:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(CapSuaChuaSearchInput, {
                      "full-width": "",
                      "prop-name": "capSuaChuaId",
                      onClear: _cache[4] || (_cache[4] = () => (form.value.capSuaChuaId = -1)),
                      onSelect: _cache[5] || (_cache[5] = ({ id }) => (form.value.capSuaChuaId = id))
                    })
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-text-muted": false,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Toa xe "),
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          content: "vui lòng chọn cấp sửa chữa trước",
                          effect: "dark",
                          placement: "top-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(IconInfoCircleClassicSolid, {
                              class: "w-5 h-5",
                              style: {"fill":"#f97316"}
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "col-4": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      prop: "toaXeId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.toaXeId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.toaXeId) = $event)),
                          class: "w-100",
                          clearable: "",
                          "default-first-option": "",
                          disabled: form.value.capSuaChuaId === -1,
                          filterable: "",
                          remote: "",
                          placeholder: "Tìm kiếm",
                          "remote-method": _unref(searchToaXe),
                          loading: searchingToaXe.value,
                          "loading-text": "đang tìm kiếm ...",
                          name: "toaXeId",
                          "no-match-text": "Không tìm thấy kết quả",
                          "no-data-text": "Không tìm thấy kết quả",
                          onClear: _cache[7] || (_cache[7] = 
                  () => {
                    form.value.toaXeId = -1;
                    toaXeTheoCapSuaChuaItems.value = [];
                  }
                )
                        }, {
                          default: _withCtx(() => [
                            (toaXeTheoCapSuaChuaItems.value.length === 0)
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  disabled: "",
                                  label: "Chưa chọn",
                                  value: -1
                                }))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toaXeTheoCapSuaChuaItems.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.toa_xe.id,
                                label: 
                    item.toa_xe.ma_toa_xe + ' - ' + item.toa_xe.ten_toa_xe
                  ,
                                value: item.toa_xe.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(item.toa_xe.ma_toa_xe) + " - " + _toDisplayString(item.toa_xe.ten_toa_xe), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled", "remote-method", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(DivRow),
                _createVNode(DivRow, null, {
                  default: _withCtx(() => [
                    _createVNode(DivCol, { cols: 8 }),
                    _createVNode(DivCol, {
                      cols: 4,
                      class: "d-flex justify-content-end"
                    }, {
                      default: _withCtx(() => [
                        (showPrintButton.value)
                          ? (_openBlock(), _createBlock(ButtonCustom, {
                              key: 0,
                              "button-type": _unref(ButtonsType).PRINT,
                              onClick: openPdfViewer
                            }, {
                              "button-label": _withCtx(() => [
                                _createTextVNode("In phiếu")
                              ]),
                              _: 1
                            }, 8, ["button-type"]))
                          : _createCommentVNode("", true),
                        _createVNode(ButtonCustom, {
                          "button-type": _unref(ButtonsType).FA_FILE_EXPORT_THIN,
                          "color-type": _unref(ButtonTypeColors).SUCCESS,
                          "tooltip-message": "Xuất báo cáo",
                          onClick: generateBaoCao
                        }, null, 8, ["button-type", "color-type"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ChiTietXuatTable, {
                "is-print-modal": false,
                items: chiTietXuatItems.value,
                stripe: true
              }, null, 8, ["items"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})